import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

export function MoreInfo({ title, children, testid = "more-info" }) {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid={testid}>
      <button type="button" onClick={() => setOpen((o) => !o)} className="app-text-button flex items-center gap-1.5 text-sm text-primary hover:underline" data-testid={`${testid}-toggle`}>
        {open ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />} {title}
      </button>
      {open && <div className="mt-2" data-testid={`${testid}-content`}>{children}</div>}
    </div>
  );
}
